<app-pan-button color="primary" icon="add" (click)="params.addCallback()" matTooltip="Add Location"></app-pan-button>
